import axios from 'axios';
import getConfig from 'next/config';
import { getKeycloakInstance } from '@react-keycloak-fork/ssr';

const { publicRuntimeConfig } = getConfig();
const anonymousRequest = axios.create({ baseURL: publicRuntimeConfig.apiUrl });
const request = axios.create({ baseURL: publicRuntimeConfig.apiUrl });

request.interceptors.request.use(async config => {
    const { token } = getKeycloakInstance();
    config.headers.Authorization = `Bearer ${token}`; // eslint-disable-line no-param-reassign
    return config;
});

export async function getAffiliates({ details } = { }) {
    const { data: { affiliates } } = await anonymousRequest('/affiliates', { params: { details } });
    return affiliates;
}

export async function getAffiliate(affiliateId, { details } = { }) {
    const { data: { affiliate } } = await request(`/affiliates/${affiliateId}`, { params: { details } });
    return affiliate;
}

export async function getAffiliateBySlug(slug, { details } = { }) {
    let affiliate;
    try {
        ({ data: { affiliate } } = await anonymousRequest('/affiliates/bySlug', { params: { slug, details } }));
    } catch (error) {
        if (error.response.status === 404) {
            return;
        }
        throw error;
    }
    return affiliate;
}

export async function getAffiliateByAffiliateCode(affiliateCode, { details } = { }) {
    let affiliate;
    try {
        ({ data: { affiliate } } = await anonymousRequest('/affiliates/byAffiliateCode', { params: { affiliateCode, details } }));
    } catch (error) {
        if (error.response.status === 404) {
            return;
        }
        throw error;
    }
    return affiliate;
}


export async function getAffiliateProduct(affiliateId, { details } = { }) {

    // const { data: { affiliate } } = await request(`/products`, { params: { details } });
    // return affiliate;
    const result = {
        'id': 'penly',
        'name': 'Penly',
        'slug': 'penly',
        'default': true,
        'primaryColor': '#478589',
        'primaryTextColor': '#fff',
        'secondaryColor': '#f09761',
        'secondaryTextColor': '#fff',
        'logoUrl': '/static/gfx/PenlyLogo.svg',
        'logoUrlInverted': '/static/gfx/PenlyLogoWhite.svg',
        'valueTitle': 'Penly fordele',
        'contact': {
            'name': 'Kourosh',
            'email': 'kontakt@penly.dk',
        },
        'products': {
            'economy-advisory-full': {
                'hidden': false,
                'id': 'economy-advisory-full',
                'categories': [
                    'economy',
                    'law',
                ],
                'slug': 'oekonomitjek',
                'name': 'ABONNEMENT Penly Nedsparings-Plan',
                'type': 'product',
                'price': { standard: 4999, now: 3999, yearly: true },
                'highlight': 'Uvildig rådgivning',
                'cta': 'Vælg',
                'descriptionShort': 'Skræddersyet pensionsstøtte hele vejen.',
                'description': `<ul><li>Få tilpasset din
nedsparingsplan og
budget efter behov.</li>
<li>Mulighed for løbende
samtaler med en uvildig
rådgiver.</li>
</ul>`,
                'valueDescription': '',
                'advisorId': 'penly-konsulenterne',
                'goToCustomFlow': true,
                'requiredScopes': {
                    'insurance': {
                        'all': true,
                    },
                    'pension': {
                        'all': true,
                    },
                    'properties': {
                        'all': true,
                    },
                    'budget': {
                        'all': true,
                    },
                    'debt': {
                        'all': true,
                    },
                    'savings': {
                        'all': true,
                    },
                    'surveys': {
                        'confidenceInPersonalEconomy': true,
                    },
                },
                'receipt': {
                    'text': '\n## Vi glæder os til at tage dig igennem ØkonomiTjekket.\n\nVælg et tidspunkt for det første møde med konsulenten. Mødet foregår online og tager ca. 30 minutter.\n                ',
                    'cta': {
                        'text': 'Book møde i Calendly nu',
                        'url': 'https://calendly.com/penly/opstartsmoede-oekonomitjek',
                    },
                },
                'productId': 'economy-advisory-full',
                'affiliateId': 'penly',
            },

            'economy-advisory-full1': {
                'hidden': false,
                'id': 'economy-advisory-full1',
                'categories': [
                    'economy',
                    'law',
                ],
                'slug': 'oekonomitjek',
                'name': 'ABONNEMENT Penly Investerings-Plan',
                'type': 'product',

                'price': { standard: 4999, now: 3999, yearly: true },
                'highlight': 'Uvildig rådgivning',
                'cta': 'Vælg',
                'descriptionShort': 'Maksimer dine investeringer',
                'description': `
         <ul>
         <li>
        Omkostningsbesparels
er ved at optimere din
portefølje.
         </li>
         <li>
         Tilpasset risikoplan,
der matcher dine
udbetalingsbehov.
         </li>
         <li>
         Årlig rapport og
benchmarksammen-
ligning for at holde
dine investeringer på
rette spor.
         </li>
         <li>
         Mulighed for løbende
samtaler med en
uvildig rådgiver.
</li>
         </ul>`,
                'valueDescription': '',

                'advisorId': 'penly-konsulenterne',
                'goToCustomFlow': true,
                'requiredScopes': {
                    'insurance': {
                        'all': true,
                    },
                    'pension': {
                        'all': true,
                    },
                    'properties': {
                        'all': true,
                    },
                    'budget': {
                        'all': true,
                    },
                    'debt': {
                        'all': true,
                    },
                    'savings': {
                        'all': true,
                    },
                    'surveys': {
                        'confidenceInPersonalEconomy': true,
                    },
                },
                'receipt': {
                    'text': '\n## Vi glæder os til at tage dig igennem ØkonomiTjekket.\n\nVælg et tidspunkt for det første møde med konsulenten. Mødet foregår online og tager ca. 30 minutter.\n                ',
                    'cta': {
                        'text': 'Book møde i Calendly nu',
                        'url': 'https://calendly.com/penly/opstartsmoede-oekonomitjek',
                    },
                },
                'productId': 'economy-advisory-full',
                'affiliateId': 'penly',
            },



            'economy-advisory-full3': {
                'hidden': false,
                'id': 'economy-advisory-full3',
                'categories': [
                    'economy',
                    'law',
                ],
                'slug': 'oekonomitjek',
                'name': 'ABONNEMENT PENLY LÅNEOVERVÅGNING',
                'type': 'product',

                'price': { standard: 3000, now: 2388, yearly: true },
                'highlight': 'Uvildig rådgivning',
                'cta': 'Vælg',
                'descriptionShort': `Få besked så snart
det er fordelagtigt
at omlægge`,
                'description': `<ul>
        <li>
        Vær først i køen ved
renteændringer, så du
kan konvertere på det
bedste tidspunkt.
        </li>
        <li>
        Få hjælp til frigørelse
af friværdi ved
tillægslån eller
optagelse af nyt lån.
        </li>
        <li>
        Bemærk, at
låneovervågning kun
er relevant ved
restgæld på min. 2
mio. kr.
        </li>
        
        </ul>`,
                'valueDescription': '',

                'advisorId': 'penly-konsulenterne',
                'goToCustomFlow': true,
                'requiredScopes': {
                    'insurance': {
                        'all': true,
                    },
                    'pension': {
                        'all': true,
                    },
                    'properties': {
                        'all': true,
                    },
                    'budget': {
                        'all': true,
                    },
                    'debt': {
                        'all': true,
                    },
                    'savings': {
                        'all': true,
                    },
                    'surveys': {
                        'confidenceInPersonalEconomy': true,
                    },
                },
                'receipt': {
                    'text': '\n## Vi glæder os til at tage dig igennem ØkonomiTjekket.\n\nVælg et tidspunkt for det første møde med konsulenten. Mødet foregår online og tager ca. 30 minutter.\n                ',
                    'cta': {
                        'text': 'Book møde i Calendly nu',
                        'url': 'https://calendly.com/penly/opstartsmoede-oekonomitjek',
                    },
                },
                'productId': 'economy-advisory-full',
                'affiliateId': 'penly',
            },


        },

    };

    return result;
}
